import React, { useEffect, useState } from 'react'
import Popup from '../../Product/components/organisms/Popup'
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api'
import { fromAddress, setKey } from 'react-geocode'
import PrimaryButton from '../../Product/components/atoms/PrimaryButton'
import './LocationHours.css'

const LocationHours = (props) => {
    const getCenterForGridMap = (loc) => {
        return { lat: loc.lat, lng: loc.lng, zoom: 8 }
    }

    const checkBidShopTheme = document.body.className == 'liquidationTwo bidShop'
    const locations = [
        {
            lat: checkBidShopTheme ? 40.8883931 : 29.7120471,
            lng: checkBidShopTheme ? -80.6939643 : -95.5167979,
            name: checkBidShopTheme ? 'Ohio' : 'Houston TX',
            address: checkBidShopTheme
                ? '123, street 123, street Columbiana Ohio 234536'
                : '102 Shaver St, Pasadena, TX 77506',
            redirectionURL: checkBidShopTheme
                ? global.storeConfigration?.warehouse_redirection_url?.value
                : 'https://maps.app.goo.gl/FMMh2dQ5JsMRryk58',
            openHours: [
                { day: 'Monday', hours: '09:30 am - 07:00 pm' },
                { day: 'Tuesday', hours: '09:30 am - 07:00 pm' },
                { day: 'Wednesday', hours: '09:30 am - 07:00 pm' },
                { day: 'Thurdsay', hours: '09:30 am - 07:00 pm' },
                { day: 'Friday', hours: '09:30 am - 07:00 pm' },
                { day: 'Saturday', hours: '09:30 am - 07:00 pm' },
                { day: 'Sunday', hours: 'Closed' },
            ],
        },
    ]

    const style = {
        height: '350px',
        maxWidth: '500px',
        width: '100%',
        border: '10px solid #fff',
        margin: '10px 0 0 auto',
    }

    const handleLocation = (address) => {
        window.open(address, '_blank')
    }

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: 'AIzaSyANJvSnxieaGRhq_Ndt1Fe4MKDkDYE-SOM',
    })

    setKey('AIzaSyANJvSnxieaGRhq_Ndt1Fe4MKDkDYE-SOM')

    const [map, setMap] = useState(null)

    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, [])
    return (
        <Popup
            {...props}
            size="md"
            modalClass={`save-search-modal ${props.classNames}`}
            modaltitle={'Location & Hours'}
        >
            <>
                {global.storeDetails.site_id === 'AS0698' ||
                global.storeDetails.site_id === 'AS0575' ||
                checkBidShopTheme ? (
                    <>
                        {isLoaded ? (
                            <div className="location_hours_card_container">
                                {locations.map((data, index) => (
                                    <div className="location_hours_card">
                                        <GoogleMap
                                            mapContainerStyle={style}
                                            mapView={true}
                                            center={getCenterForGridMap({
                                                lat: data.lat,
                                                lng: data.lng,
                                            })}
                                            zoom={8}
                                            onUnmount={onUnmount}
                                        >
                                            <Marker
                                                position={{ lat: data.lat, lng: data.lng }}
                                                onClick={() => handleLocation(data.redirectionURL)}
                                            />
                                        </GoogleMap>
                                        <div className="location_card_content">
                                            <h4>{data.name}</h4>
                                            <p>{data.address}</p>
                                        </div>
                                        <div className="location_hours_card_box">
                                            <PrimaryButton
                                                label="Get Direction"
                                                onClick={() => handleLocation(data.redirectionURL)}
                                            />
                                            <ul className="hours_list">
                                                <li className="hours_title">Location Hours</li>
                                                <li className="hours_list_items">
                                                    {data.openHours.map((d, i) => (
                                                        <div>
                                                            <span>{d.day}:</span>
                                                            <span>{d.hours}</span>
                                                        </div>
                                                    ))}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : null}
                    </>
                ) : null}
            </>
        </Popup>
    )
}

export default LocationHours
